import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
const features = ['116 páginas · 8 habilidades esenciales', 'BONUS 1: Banco de Producciones Escritas', 'BONUS 2: Banco de Debates para Secundaria', 'BONUS 3: 50 Actividades de Ciudadanía', 'BONUS 4: Del Aula al Mundo', 'Acceso inmediato y de por vida'];
const CHECKOUT_URL = 'https://checkout.aula-mater.online/cart/67392862584877:1';
export function PurchaseSection() {
  return <section id="compra" className="py-10 px-4 bg-black text-white text-center" data-id="element-104" data-mp="354un55bd4nt3">
      <div className="max-w-5xl mx-auto" data-id="element-105" data-mp="35308u9uljtxz">
        <h2 className="text-[20px] md:text-2xl font-black mb-2 text-white" data-id="element-106" data-mp="3ju0haevcfnu4">
          Accedé ahora a 8 HABILIDADES PARA SECUNDARIA
        </h2>

        <p className="text-lg md:text-xl font-medium mb-8 max-w-2xl mx-auto text-gray-300" data-id="element-107" data-mp="3ewqu75vffo9g">
          Pago único · Acceso de por vida.
        </p>

        <div className="max-w-md mx-auto" data-id="element-108" data-mp="3otmtckzfqy1c">
          <div className="flex flex-col rounded-3xl p-6 md:p-7 text-left shadow-2xl border-2 bg-gray-900 border-[#17A2AE]" data-id="element-109" data-mp="3ouoh9q1jvf0h">
            <span className="inline-block self-start text-[10px] md:text-xs font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wide bg-[#17A2AE] text-white" data-id="element-110" data-mp="127goiz8oz1zl">
              Material completo
            </span>

            <h3 className="text-2xl md:text-[26px] font-black mb-1 text-white leading-tight" data-id="element-111" data-mp="1c65v3vv5100j">
              8 Habilidades para Secundaria
            </h3>

            <ul className="space-y-2 mb-6 mt-3" data-id="element-112" data-mp="1h4h6wc4ztkle">
              {features.map(f => <li key={f} className="flex items-start text-sm md:text-base" data-id="element-113" data-mp="1l4rmmgil7pdg">
                  <CheckIcon className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5 text-green-500" data-id="element-114" data-mp="1py2mtysw97we" />
                  <span className="text-gray-200" data-id="element-115" data-mp="1uv2ps0ug5uja">{f}</span>
                </li>)}
            </ul>

            <div className="flex items-end justify-center h-48 mb-4" data-id="element-116" data-mp="1zwia1qosvx0m">
              <img src="https://cdn.magicpatterns.com/uploads/oqQ5tJksQY6ihcLkMfq1Ex/IMAGEN_PRINCIPAL.png" alt="8 Habilidades para Secundaria" className="h-full w-auto object-contain drop-shadow-xl" data-id="element-117" data-mp="24tsae1dq9t38" />
            </div>

            <div className="mb-4" data-id="element-118" data-mp="1ovzf0uzhs3v2">
              <div className="flex items-center gap-2 mb-1" data-id="element-119" data-mp="1ox0y9mqnvwnv">
                <span className="text-lg font-bold line-through text-gray-500" data-id="element-120" data-mp="1k594z4g4fcu1">
                  ARS $39.990
                </span>
                <span className="bg-red-600 text-white text-xs font-black px-2.5 py-1 rounded-full" data-id="element-121" data-mp="1xvmfneked5n2">
                  50% OFF
                </span>
              </div>
              <span className="text-sm font-bold align-top mr-1 text-gray-400" data-id="element-122" data-mp="27uk1g9qful2d">
                ARS
              </span>
              <span className="text-4xl md:text-5xl font-black text-white" data-id="element-123" data-mp="22vh7bkbzxz96">
                $19.990
              </span>
              <p className="text-xs mt-1 text-gray-400" data-id="element-124" data-mp="dhlthws7o0i7">
                Pago único · Acceso de por vida
              </p>
            </div>

            <CTAButton href={CHECKOUT_URL} className="w-full text-lg md:text-xl py-4" data-id="element-125" data-mp="8k2bqmwb15li">
              👉 LO QUIERO
            </CTAButton>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-sm font-bold text-gray-300 mt-6" data-id="element-126" data-mp="2p2uq1qxo0x4c">
            <span className="flex items-center" data-id="element-127" data-mp="2ad5kzkmgc8ys">
              <span className="text-green-500 mr-1" data-id="element-128" data-mp="2fdkws7r358en">✔</span> para 12 a 18 años
            </span>
            <span className="flex items-center" data-id="element-129" data-mp="21e1y05k5z9f0">
              <span className="text-green-500 mr-1" data-id="element-130" data-mp="21da7381ihzv2">✔</span> acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-131" data-mp="25hhxrarj5pvx">
              <span className="text-green-500 mr-1" data-id="element-132" data-mp="1rgx9w06rd3vk">✔</span> descarga digital
            </span>
          </div>
        </div>
      </div>
    </section>;
}